import React, { SyntheticEvent } from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../reducers';
import {
  getBearerToken,
  getWordPair,
  toggleRemembered,
  toggleShowTranslation,
  remember,
  forget,
} from '../../actions';
import { WordPair } from "../../models";
import './index.scss';

interface IProps {
  wordPair: WordPair|null;
  showRemembered: boolean;
  showTranslation: boolean;

  getBearerToken(): void;
  getWordPair(): void;
  toggleRemembered(): void;
  toggleShowTranslation(): void;
  remember(id: number): void;
  forget(id: number): void;
}

class WordPairContainer extends React.PureComponent<IProps> {
  componentDidMount(): void {
    const { getWordPair, getBearerToken } = this.props;
    getBearerToken();
    getWordPair();
  }

  remember = (id: number) => (e: SyntheticEvent) => {
    e.stopPropagation();
    this.props.remember(id)
  };

  forget = (id: number) => (e: SyntheticEvent) => {
    e.stopPropagation();
    this.props.forget(id)
  };

  render() {
    const { wordPair, showRemembered, toggleRemembered, getWordPair, showTranslation, toggleShowTranslation } = this.props;
    if (!wordPair) {
      return null;
    }

    return (
      <div className='app-wrapper'>
        <div className='word-pair-wrapper'>
          <div className='word-pair-item-wrapper from'>
            <span className='word-pair-item from'>{wordPair.from}</span>
          </div>
          <div onClick={showTranslation ? getWordPair : toggleShowTranslation} className='word-pair-item-wrapper to'>
            {showTranslation &&
              <>
                <div
                  className='remember-wrapper button'
                  onClick={wordPair.remembered ? this.forget(wordPair.id) : this.remember(wordPair.id)}
                >
                  <span className='remember'>{wordPair.remembered ? 'forget' : 'remember'}</span>
                </div>
                <div className='word-pair-item to'>{wordPair.to}</div>
                {wordPair.options.length &&
                <div>
                  {wordPair.options.map(wp => (
                    <>
                      <small key={wp.id}>{wp.to}</small>{'  '}
                    </>
                  ))}
                </div>}
              </>
            }
          </div>
        </div>

        <div className='navigation-wrapper' onClick={toggleRemembered}>
          <div className='toggle-remembered button'>
            <span className=''>{`${showRemembered ? 'hide' : 'show'} remembered`}</span>
          </div>

          <div className='stats button'>
            <span className=''>go to stats</span>
          </div>
        </div>
      </div>
    );
  }
}

export default connect((state: RootState) => ({
  wordPair: state.wordPair,
  showRemembered: state.showRemembered,
  showTranslation: state.showTranslation,
}), {
  getBearerToken,
  getWordPair,
  toggleRemembered,
  toggleShowTranslation: toggleShowTranslation,
  remember,
  forget,
})(WordPairContainer);
